module.exports = __webpack_public_path__ + "static/media/rotateRight.f2c27b2a.svg";